import { UPDATE_IMAGES_SUCCESS } from "../actions/image";
import {
  UPDATE_IMAGE_COLOURIZED_URL,
  UPDATE_PANEL_COLOUR_CURVE
} from "../actions/panel";
import { isEqual } from "underscore";

const initState = {
  isFetching: false,
  items: [],
  // For clarity, when populated, this object will contain a set of colourizedImageSetId keys
  // pointing to colourized images for that panel. For example,
  // colourizedImageUrls: {
  //   1-1: {
  //     '/weather/123.image': 'blob:http://plan.navcanada.ca/6013cee1-09ca-46a6-abd6-a5e81a0c04fd',
  //     '/weather/124.image': 'blob:http://plan.navcanada.ca/1234abcd-01ab-01ab-01ab-0a1b2c3d4e5f'
  //   }
  //   2-1: {
  //     '/weather/987.image': 'blob:http://plan.navcanada.ca/1234BLAH-BLAH-BL4H-81BA-ABABABABABAB'
  //   }
  //   2-2: {
  //     '/weather/987.image': 'blob:http://plan.navcanada.ca/234wert3-BLAH-BL4H-81BA-ABABABABABAB'
  //   }
  // }
  // That way, panels colourize themselves independently without threat of clobbering others. Also,
  // placing this in the `image` state instead of the `panel` state makes things easier for
  // serialization, since we can simply serialize the entire panel and not worry about omitting
  // this key or that.
  colourizedImageUrls: {}
};

/**
 * Generate a unique key for a panel and colour mapping combination
 *
 * @param panelId Unique panel ID
 * @param mappingId Unique colour mapping ID
 * @returns {string}
 */
export function colourizedImageSetId(panelId, mappingId) {
  return `${panelId}-${mappingId}`;
}

/**
 * Remove the colourized images from memory
 *
 * @param newState The state to be modified (in place)
 * @param key The key that groups the colourized images
 */
function deleteColourizedImages(newState, key) {
  const panelUrls = newState.colourizedImageUrls[key];
  const blobUrls = panelUrls ? Object.values(panelUrls) : [];
  if (blobUrls.length > 0) {
    for (let blobUrl of blobUrls) {
      (window.URL || window.webkitURL).revokeObjectURL(blobUrl);
    }
    newState.colourizedImageUrls[key] = {};
  }
}

function image(state = initState, action) {
  let newState = JSON.parse(JSON.stringify(state));

  switch (action.type) {
    case UPDATE_IMAGE_COLOURIZED_URL:
      const colourizedImageUrls = newState.colourizedImageUrls;
      let panelUrls = colourizedImageUrls[action.key];
      if (!panelUrls) {
        panelUrls = {};
        colourizedImageUrls[action.key] = panelUrls;
      }
      panelUrls[action.imgUrl] = action.colourizedImageUrl;
      return newState;

    case UPDATE_IMAGES_SUCCESS:
      return Object.assign({}, state, {
        items: isEqual(action.images, state.items)
          ? state.items
          : action.images,
        lastUpdated: action.receivedAt
      });

    case UPDATE_PANEL_COLOUR_CURVE:
      /**
       * When we switch from one mapping state to another we delete the old colour mapped images
       */
      if (action.from !== action.to) {
        deleteColourizedImages(
          newState,
          colourizedImageSetId(action.panelId, action.from)
        );
      }
      return newState;
    default:
      return newState;
  }
}

export { image as default };
